<template>
  <div class="Home">
    <el-container class="Home-container">
      <el-aside :width="!collapse ? '200px' : '64px'" class="Home-aside">
        <div style="height: 68px;" class="logo">
          <img src="" alt="" />
        </div>
        <el-menu
          class=" menucss"
          background-color="#3b4046"
          text-color="#BFCBD9"
          active-text-color="#9FD8F8"
          :unique-opened="true"
          :collapse-transition="false"
          :collapse="collapse"
          @select="MenuOpen"
          :default-active="DefaultActive"
          ref="MenuItemKeys"
        >
          <template v-for="(item, index) in menu">
            <el-submenu :key="index" v-if="item.SubMenu.length>0" :index="item.menutext">
              <template slot="title">
                <i
                  :class="['iconfont', item.iconname]"
                  style="margin-right:10px;"
                ></i>
                <span>{{ item.menutext }}</span>
              </template>
              <el-menu-item
                :index="children.url"
                v-for="children in item.SubMenu"
                :key="children.url"
                @click="TITLE = children.menutext"
              >
                <i
                  :class="['iconfont', item.iconname]"
                  style="margin-right:10px;visibility: hidden;"
                ></i>
                {{ children.menutext }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else
              class="alone-menu"
              :index="item.url"
              :key="index"
              @click="TITLE = item.menutext"
            >
              <i
                :class="['iconfont', item.iconname]"
                style="margin-right:10px;visibility: hidden;"
              ></i>
              {{ item.menutext }}
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="Home-header">
          <div class="Home-header-left">
            <p @click="collapse = !collapse">
              <i
                :class="['iconfont', iconKeys['配置']]"
                style="margin-right:10px;"
              ></i>
            </p>
            <p style="font-weight: bold;">{{ TITLE }}</p>
          </div>
          <div class="Home-header-rig">
            <!-- <el-tooltip placement="bottom">
              <div slot="content">多行信息<br />第二行信息</div> -->
            <i :class="['iconfont', iconKeys['消息']]"></i>
            <!-- </el-tooltip> -->
            <el-tooltip placement="bottom" effect="light">
              <div slot="content">
                <h2>账号信息</h2>
                <p>{{ admininfo.truename }} （{{ admininfo.act }}）</p>
                <p>ID:{{ admininfo.username.toUpperCase() }}</p>
                <p v-if="admininfo.act == '管理员'">
                  余额：{{ admininfo.balance }}
                </p>
                <h2>企业信息</h2>
                <p>企业信息：{{ admininfo.dealername }}</p>
                <p>ID:{{ admininfo.id.toUpperCase() }}</p>
              </div>
              <i :class="['iconfont', iconKeys['用户']]"></i>
            </el-tooltip>
            <!-- <el-tooltip placement="bottom" effect='light'>
              <div slot="content" @click='LoginOut'>
                退出登录
              </div> -->
            <i
              :class="['iconfont', iconKeys['注销登录']]"
              @click="LoginOut"
            ></i>
            <!-- </el-tooltip> -->
          </div>
        </el-header>
        <el-main class="Mian">
          <iframe
            :src="item.url"
            frameborder="0"
            @load="IframeLoad"
            :class="['Iframe', !item.show ? 'visibilitycss' : '']"
            v-for="item in IframeList"
            :key="item.index"
          ></iframe>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import iconKeys from "../utils/IconKey.js";
const Ifreamloding = null;
export default {
  data() {
    return {
      // Ifreamloding: null,
      DefaultActive: "",
      checkicon: true,
      iconKeys: iconKeys, //icon字段
      collapse: false,
      menu: [],
      TITLE: "上传录音",
      url: "",
      admininfo: {},
      IframeList: []
    };
  },
  methods: {
    LoginOut() {
      var r = confirm("您确定退出吗!");
      if (r == true) {
        document.cookie = `wxglweb=; expires=${new Date(0).toGMTString()}`;
        // window.location.href = `${window.location.origin}/default.aspx?id=1`
        this.$router.push({
          name: "Login"
        });
      }
    },
    MenuOpen(key, keypath) {
      console.log(key, keypath);
      let check = false;
      this.IframeList.forEach((item, index) => {
        if (`${window.location.origin}/${key}` == item.url) {
          item.show = true;
          check = true;
        } else {
          item.show = false;
        }
      });
      if (!check) {
        this.IframeList.push({
          show: true,
          url: `${window.location.origin}/${key}`
        });
      }
      this.url = `${window.location.origin}/${key}`;
    },
    // cookies 转对象
    cookieToJson() {
      let cookieArr = decodeURIComponent(document.cookie.slice(8)).split("&");
      let obj = {};
      cookieArr.forEach(i => {
        let arr = i.split("=");
        obj[arr[0]] = arr[1];
      });
      return obj;
    },

    IframeLoad() {
      console.log("iframe 加载完毕");
    },
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    MeunList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios.Getdata("Manage/GetData.aspx?action=menu").then(res => {
        loading.close();               
        let data = res.data;
        if (data.errcode == 0) {
          // data.list.push({"iconname":"icon-luyin","url":"Manage/VoicerecordUpload.aspx","menutext":"录音管理","SubMenu":[]})
          this.menu = data.list;
          let index = 0;
          for(let i in data.list[0].SubMenu){
            if(data.list[0].SubMenu[i].url.indexOf('Manage/FindVadio.html')>-1){
              index = i;
              break;
            }
          }
          this.DefaultActive = data.list[0].SubMenu[index].url;
          this.TITLE = data.list[0].SubMenu[index].menutext;
          this.url = `${window.location.origin}/${this.DefaultActive}`;
          this.IframeList.push({
            show: true,
            url: this.url
          });
        }
      });
    },

    // 获取未处理审核条数
    GetSHList() {
      this.$axios
        .Getdata("manage/Voicerecordreport.asmx/getuncheckcomplaint", {
          data: {
            cid: this.admininfo.id,
            pageindex: 1,
            pagesize: 1000,
            check: 0,
            Typename: ""
          }
        })
        .then(res => {
          console.log(res);
          if (res.data.totalcount != 0) {
            this.$message({
              message: `您有${
                res.data.totalcount > 100 ? "99+" : res.data.totalcount
              }条申诉审核未处理`
            });
          }
        });
    }
  },
  mounted() {
    // console.log(this.$axios)
  },
  created() {
    if (!this.getCookie("wxglweb")) {
      this.$router.push({
        name: "Login"
      });
      return;
    }

    this.MeunList();
    this.admininfo = this.cookieToJson();
    this.GetSHList();
    // console.log(this.admininfo)
  }
};
</script>

<style scoped>
.Home-container {
  height: 100%;
  color: #fff;
  font-size: 14px;
}

.visibilitycss {
  visibility: hidden;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
}

.logo img {
  width: 44px;
  height: 44px;
}

.iconfont {
  font-size: 18px !important;
}

.Home-header {
  display: flex;
  justify-content: space-between;
  height: 68px !important;
  align-items: center;
  background-color: #fff;
  font-size: 18px;
  color: #4c4c4c;
}

.Home-header-left {
  display: flex;
}

.Home-header-rig {
  min-width: 160px;
  display: flex;
  justify-content: space-around;
}

.Home-header-rig .iconfont {
  font-size: 26px !important;
}

.Home-header-rig h2 {
  font-size: 18px;
  font-weight: normal !important;
}

.Home-aside {
  background-color: #3b4046;
}

.Home {
  height: 100%;
}

.el-main {
  padding: 0 !important;
  /* padding-left: 15px !important; */
  /* padding-top: 15px !important; */

  background-color: #f1f1f1;
  height: 99%;
  box-sizing: border-box;
}

.el-menu {
  border: none !important;
}

.el-breadcrumb {
  padding: 10px;
  color: #fff;
}

.Mian {
  position: relative;
  width: 100%;
  height: 99%;
}

.Iframe {
  width: 100%;
  height: 99%;
  position: absolute;
  top: 0;
  left: 0;
}

.el-submenu .el-menu-item {
  height: 42px !important;
  line-height: 42px !important;
}

.el-submenu__title {
  height: 42px !important;
  line-height: 42px !important;
}

.el-menu .is-active {
  background-color: #545454 !important;
}

.el-menu-item {
  background-color: #303031 !important;
}

/*滚动条样式*/
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  background: #e0e5eb;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 0;
}
</style>
<style>
.el-table th>.cell {
    color: #4c4c4c !important;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    height: 42px;
    line-height: 42px;
}

.el-table {
    font-size: 14px;
    color: #797979;
}



.el-badge__content {
    background-color: #008dff;
    min-width: 26px;
    padding: 0;
    font-size: 14px;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
}

.el-tabs__item {
    font-size: 16px;
}


.el-form--inline .el-form-item__label {
    color: #a4a1a1;
}

.el-card {
    margin-bottom: 10px;
    box-shadow: 0px 2px 5px rgba(164, 164, 164, 0.313725490196078);
}

.el-card__body {
    padding: 16px;
}

.el-button {
    background: #4a8df0 !important;
    background-color: #4a8df0 !important;
    color: #fff;
    font-size: 14px !important;
    font-family: "å¾®è½¯é›…é»‘" !important;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 172px;
}

.el-pagination__sizes .el-input__inner {
    width: 100px;
}

.el-table .el-button {
    background: none !important;
    background-color: none !important;
    color: #409EFF;
}
.Home .alone-menu{
  background: rgb(59, 64, 70) !important;
}
</style>
